module.exports = __webpack_public_path__ + "img/varauslaavu_original.b370592b.jpg";